import React from 'react';
import classnames from 'classnames';
import { BadgeProps } from './types';
import s from './index.module.scss';

export const Badge = ({
  label,
  type = 'neutral',
  appearance = 'filled',
  size = 'medium',
  numeric = false,
  dot = false,
  className,
  ...props
  }: BadgeProps) => {
  return (
    <div
      className={classnames(
        s.badge,
        `type_${type}`,
        `appearance_${appearance}`,
        `size_${size}`,
        numeric && 'numeric',
        dot && 'dot',
        className
      )}
      {...props}
    >
      {label}
    </div>
  );
};